var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoSights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 900",
    width: 900,
    height: 900,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Folder 1 copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape 3",
    fillRule: "evenodd",
    className: "s0",
    d: "m450.1 862.1c-227.8 0-411.9-184.1-411.9-412 0-227.8 184.1-411.9 411.9-411.9 227.9 0 412 184.1 412 411.9 0 227.9-184.1 412-412 412zm-179.1-447.1c0 0 107.4-307.4 412-171 0 0-100-151.3-285-77-185 74.3-119.4 297.7-127 248zm73 218c0 0-252.5-104.8-134.3-407.4 0 0-193.7 214.4-14.7 444.4 179 230 489.9 106.7 545-42 55.1-148.7-34.7-276.7-166-296-131.3-19.3-306.1 101.2-230 301z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoSights);
export default __webpack_public_path__ + "static/media/auto_sights.3f66519e180bd8ee94ea9a6d29af4cca.svg";
export { ForwardRef as ReactComponent };